import { render, staticRenderFns } from "./RouteList.vue?vue&type=template&id=f13a09ba&"
import script from "./RouteList.vue?vue&type=script&lang=ts&"
export * from "./RouteList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports